import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Certificate, DeleteCertificateRequest } from "./types";

export const deleteCertificateRequest = (certificate: Certificate) =>
  apiProxyRequest<DeleteCertificateRequest>(
    certificate._links?.["#delete"]!.href,
    "DELETE"
  );
